export default "__VITE_ASSET__21e48b08__"